import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-sentiment-badge',
  templateUrl: './sentiment-badge.component.html',
  styleUrls: ['./sentiment-badge.component.scss']
})
export class SentimentBadgeComponent {
  @Input() sentiment: 'positive' | 'neutral' | 'negative' = 'neutral';

  get label(): string {
    if (this.sentiment === 'positive') {
      return 'Positive';
    }
    if (this.sentiment === 'negative') {
      return 'Negative';
    }
    return 'Neutral';
  }
}
